import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BarChartReadComponent } from '../bar-chart-read/bar-chart-read.component';

@Component({
  selector: 'app-bar-chart-answered',
  templateUrl: './bar-chart-answered.component.html',
  styleUrls: ['./bar-chart-answered.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class BarChartAnsweredComponent extends BarChartReadComponent {
  type = 'answered'
  colorScheme = {
    domain: ['#32db64']
  };  

}    